<template>
  <div
    :class="[
      'x-tag',
      color,
      size
    ]"
  >
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'x-tag',
  props: {
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'gray'
    },
    size: {
      type: String,
      default: 'regular'
    }
  },

  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/styles/vars.scss';

  .x-tag {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    border-radius: 3px;
    color: $color-galaxy;
    font-weight: 600;

    &.regular {
      font-size: 1.4rem;
      padding: $space-small;
    }

    &.small {
      font-size: 1rem;
      padding: calc(#{$space-small} / 1.5);
    }

    &.gray {
      background: $color-silver;
    }

    &.white {
      background: #FFF;
    }

    &.green {
      background: #EAFAF4;
      color: $color-meadow;
    }

    &.yellow {
      background-color: #FEF2DE;
      color: #F5A623;
    }

    &.red {
      background-color: #F8DEDE;
      color: #EA4C4D;
    }

    &.daddy {
      background-color: rgba(#979DAD, 0.2);
      color: #5C6B7E;
    }
  }
</style>